import { render } from "./SBtnEsia.vue?vue&type=template&id=1d9b0fb4&ts=true"
import script from "./SBtnEsia.vue?vue&type=script&lang=ts"
export * from "./SBtnEsia.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__